import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetStore } from '@/Infrastructure/applicationSlice';

interface DispatchBoardState {
  loadingSet: number[];
}

const initialState: DispatchBoardState = {
  loadingSet: []
};

/**
 * Dispatch Board State used for providing visual feedback on the row(s) being mutated.
 * API mutations will add leg id(s) to the loading set to be handled by the Dispatch Board
 * checkbox column renderer.
 */
const dispatchBoardSlice = createSlice({
  name: 'dispatchBoardState',
  initialState,
  reducers: {
    /** Add a leg or legs to the loading set */
    setLegLoading(state, action: PayloadAction<number | number[]>) {
      const payload = ([] as number[]).concat(action.payload);
      return {
        ...state,
        loadingSet: [...state.loadingSet, ...payload]
      };
    },
    clearLegFeedback(state, action: PayloadAction<number | number[]>) {
      const payload = ([] as number[]).concat(action.payload);
      const newLoadingSet = [...state.loadingSet];
      // Remove only the first occurrence of each leg id so that legs queued by
      // multiple in-flight actions remain in the loading set until each call completes.
      for (const legId of payload) {
        const index = newLoadingSet.indexOf(legId);
        if (index !== -1) {
          newLoadingSet.splice(index, 1);
        }
      }
      return {
        ...state,
        loadingSet: newLoadingSet
      };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => {
      return initialState;
    });
  }
});

export const { setLegLoading, clearLegFeedback } = dispatchBoardSlice.actions;

export default dispatchBoardSlice;
